<template>
  <div>
    <div class="col s12 m6 l4">
      <div class="card sticky-action" style="width:100%;">
        <table>
          <div @submit.prevent="Get_publ_scopus_intermediate_amount">
            <caption class="messageoutput" >ЭТАП 2. ЗАГРУЗКА И ПРОВЕРКА ДАННЫХ О ПУБЛИКАЦИЯХ В БД НГТУ (на основании данных, имеющихся в промежуточной БД)</caption>
            <tr>
              <td colspan="3" class="form_description">
                Для получения информации о количестве публикаций, подлежащих анализу за указанный период, заполните форму ниже, затем нажмите на кнопку 'Получить информацию'. Рекомендуется загружать публикации в рамках одного года.
              </td>
            </tr>
            <tr>
              <td>Год, за который требуется загрузить публикации:
                <span class="input-field">
                  <span v-if="checked === 'no'">
                    <input type="number" v-model="yearPubl2" id="Year_0" name="tentacles" min="1500" max="9999" style="width:60px; height:18px;" class="card-content red-text" :class="{ invalid: ( $v.yearPubl2.$dirty && !$v.yearPubl2.required && checked === 'no') || ( $v.yearPubl2.$dirty && !$v.yearPubl2.minLength && checked === 'no') }"> г.
                    <small
                      class="helper-text invalid"
                      v-if="$v.yearPubl2.$dirty && !$v.yearPubl2.required && checked === 'no'"
                    >Поле год является обязательным для заполнения (формат данных: число)!
                    </small>
                    <small
                      class="helper-text invalid"
                      v-else-if="$v.yearPubl2.$dirty && !$v.yearPubl2.minLength && checked === 'no'"
                    >Год должен состоять из {{ $v.yearPubl2.$params.minLength.min }} цифр. Сейчас количество цифр: {{yearPubl2.length}} шт.
                    </small>
                  </span>
                </span>
                <span class="input-field">
                  <span v-if="checked === 'yes'">
                    c <input type="number" v-model="yearPubl1" id="Year_1" name="tentacles" min="1500" max="9999" style="width:60px; height:18px;" class="card-content red-text" :class="{ invalid: ( $v.yearPubl1.$dirty && !$v.yearPubl1.required && checked === 'yes') || ( $v.yearPubl1.$dirty && !$v.yearPubl1.minLength && checked === 'yes') }">
                    по <input type="number" v-model="yearPubl2" id="Year_2" name="tentacles" min="1500" max="9999" style="width:60px; height:18px;" class="card-content red-text" :class="{ invalid: ( $v.yearPubl2.$dirty && !$v.yearPubl2.required && checked === 'yes') || ( $v.yearPubl2.$dirty && !$v.yearPubl2.minLength && checked === 'yes') }"> гг.
                    <div>
                    <small
                      class="helper-text invalid"
                      v-if="$v.yearPubl1.$dirty && !$v.yearPubl1.required  && checked === 'yes'"
                    >Поле для ввода начала периода ('с') является обязательным для заполнения (формат данных: число)!
                    </small>
                    <small
                      class="helper-text invalid"
                      v-else-if="$v.yearPubl1.$dirty && !$v.yearPubl1.minLength  && checked === 'yes'"
                    >Год (поле 'с') должен состоять из {{ $v.yearPubl1.$params.minLength.min }} цифр. Сейчас количество цифр: {{yearPubl1.length}} шт.
                    </small>
                    </div>
                    <div>
                    <small
                      class="helper-text invalid"
                      v-if="$v.yearPubl2.$dirty && !$v.yearPubl2.required && checked === 'yes'"
                    >Поле для ввода окончания периода ('по') является обязательным для заполнения (формат данных: число)!!
                    </small>
                    <small
                      class="helper-text invalid"
                      v-else-if="$v.yearPubl2.$dirty && !$v.yearPubl2.minLength && checked === 'yes'"
                    >Год (поле 'по') должен состоять из {{ $v.yearPubl2.$params.minLength.min }} цифр. Сейчас количество цифр: {{yearPubl2.length}} шт.
                    </small>
                    </div>
                  </span>
                </span>
                <span>
                  <label><input v-model="checked" true-value="yes" false-value="no" id="checkbox" type="checkbox"/><span>Ввести временной диапазон</span></label>
                </span>
              </td>
              <td>
                <button :disabled="isButtonDisabled" class="btn-small btn-primary" @click="Get_publ_scopus_intermediate_amount">Получить информацию<i class="material-icons right">send</i></button>
              </td>
            </tr>
          </div>
          <tr>
            <div v-if="loading === false">
              <!--        <tr v-if="counter === 1">-->
              <!--          <Loader v-if="loading === true" />-->
              <!--          <div v-else class="row">-->
              <span class="messageoutput">Операция выполняется, пожалуйста, подождите!</span>
              <div class="progress"><div class="indeterminate"></div></div>
            </div>
          </tr>
          <!--если лимит Не превышен, то:-->
          <div v-if="getPublScopusIntermediateAmount === 3">
            <tr>
              <td>Количество публикаций, подлежащих анализу за указанный период
                <span v-if="checked === 'no'">
                ({{yearName}} г.):
                </span>
                <span v-if="checked === 'yes'">
                ({{yearName}} гг.):
                  <!--({{yearPubl1 + '-' + yearPubl2}}) выше изменено, что при нажатии на кнопку менялось-->
              </span>
                <span class="colortext"> {{ getPublScopusAmount.number_publications  }} </span> шт. (в промежуточной БД)
              </td>
            </tr>
            <td>
             <span>
               <button :disabled="isButtonDisabled_2" class="btn btn-primary" @click="load_publications_in_nstu">Запустить загрузку и проверку публикации в БД НГТУ<i class="material-icons right">send</i></button>
               <span v-if="loadpublicationsinnstustatus === -1 && lenListPublId!==0">
                 (загрузка и проверка публикаций ориентировочно займет:
                 <span v-if="hours !== 0">
                   {{this.hours}} ч.
                 </span>
                  <span v-if="minutes !== 0">
                   {{this.minutes}} мин.
                 </span>
                 <span v-if="seconds !== 0">
                   {{this.seconds }} сек.)
                 </span>
               </span>
             </span>
            </td>
            <tr>
                <span class="form_description" v-if="loadpublicationsinnstustatus === -1 && lenListPublId!==0">
                  По окончании выполнения данной операции будет сформирован отчет о всех внесенных изменениях, а также выявленных несостыковках в данных для уже имеющихся публикаций.
                </span>
              <!--                <button class="btn btn-primary" @click="loadpublicationsinnstu" :disabled="{false: (getQuotaAndPubl.len_list_publ_id > 1)  || isButtonDisabled: (getQuotaAndPubl.len_list_publ_id >= 1)}">Загрузить публикации в промежуточную БД<i class="material-icons right">send</i></button>-->
              <span v-if="isButtonDisabled_2 === false">
                  <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
                 </span>
              <span v-if="lenListPublId===0">
                    <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
                   </span>
            </tr>
            <tr>
              <div v-if="loading_2 === false">
                <!--        <tr v-if="counter === 1">-->
                <!--          <Loader v-if="loading === true" />-->
                <!--          <div v-else class="row">-->
                <span class="messageoutput">Операция выполняется. По окончании выполнения операции на экране появится соответствующее сообщение.</span>
                <div class="progress"><div class="indeterminate"></div></div>
              </div>
            </tr>
            <!--Дата некорректна-->
            <div v-if="loadpublicationsinnstustatus === 33">
              <tr>
                <td class="messageoutput">
                  Загрузка новых публикаций в БД НГТУ за указанный промежуток времени ({{yearName}} г.) осуществлена успешно!
                  Загруженные публикации в количестве {{this.number_publications_add_nstu}} шт. находятся в стадии редактирования у соответствующих авторов для возможности внесения недостающих данных, к которым может относиться, например, поле "Название госзадания".
                  Публикации будут доступны в пункте <a target="_blank" href="https://ciu.nstu.ru/library_admin/publication/publication_list">'Список научных публикаций'</a> раздела 'Проверка печатных работ' после того, как автор отправит публикацию на проверку в библиотеку.
                  Внесенные изменения для уже имеющихся публикаций, а также выявленные нестыковки в данных содержатся в отчете Excel.
                </td>
                <button type="button" @click="cleaningForm"><i>закрыть информацию о загрузке</i></button>
              </tr>
            </div>
            <div v-else-if="loadpublicationsinnstustatus === 34">
              <tr>
                <td class="messageoutput">
                  Новых публикаций не выявлено. Внесенные изменения для уже имеющихся публикаций и/или выявленные нестыковки в данных содержатся в отчете Excel.
                  <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
                </td>
              </tr>
            </div>
            <div v-else-if="loadpublicationsinnstustatus === 33">
              <tr>
                <td class="messageoutput">
                  Загрузка новых публикаций в БД НГТУ за указанный промежуток времени ({{yearName}} г.) осуществлена успешно!
                  Загруженные публикации в количестве {{this.number_publications_add_nstu}} шт. находятся в стадии редактирования у соответствующих авторов для возможности внесения недостающих данных, к которым может относиться, например, поле "Название госзадания".
                  Публикации будут доступны в пункте <a target="_blank" href="https://ciu.nstu.ru/library_admin/publication/publication_list">'Список научных публикаций'</a> раздела 'Проверка печатных работ' после того, как автор отправит публикацию на проверку в библиотеку.
                  Внесенные изменения для уже имеющихся публикаций, а также выявленные нестыковки в данных содержатся в отчете Excel.
                  <button type="button" @click="cleaningForm"><i>закрыть информацию о загрузке</i></button>
                </td>
              </tr>
            </div>
            <div v-else-if="loadpublicationsinnstustatus === 35">
              <tr>
                <td class="messageoutput">
                  Загрузка новых публикаций в БД НГТУ за указанный промежуток времени ({{yearName}} г.) осуществлена успешно!
                  Загруженные публикации в количестве {{this.number_publications_add_nstu}} шт. находятся в стадии редактирования у соответствующих авторов для возможности внесения недостающих данных, к которым может относиться, например, поле "Название госзадания".
                  Публикации будут доступны в пункте <a target="_blank" href="https://ciu.nstu.ru/library_admin/publication/publication_list">'Список научных публикаций'</a> раздела 'Проверка печатных работ' после того, как автор отправит публикацию на проверку в библиотеку.
                  Несостыковок в данных и отсутствие киких-либо данных о публикациях не обнаружено.
                  <button type="button" @click="cleaningForm"><i>закрыть информацию о загрузке</i></button>
                </td>
              </tr>
            </div>
            <div v-else-if="loadpublicationsinnstustatus === 36">
              <tr>
                <td class="messageoutput">
                  Новых публикаций не выявлено. Несостыковок в данных и отсутствие киких-либо данных о публикациях не обнаружено.
                  <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
                </td>
              </tr>
            </div>
            <div v-else-if="loadpublicationsinnstustatus === 4">
              <tr>
                <td class="helper-text invalid">
                  В процессе операции (на стороне backend) произошла ошибка. Пожалуйста, обратитесь к администратору системы.
                  <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
                </td>
              </tr>
            </div>
            <div v-else-if="loadpublicationsinnstustatus === 5">
              <tr>
                <td class="helper-text invalid">
                  Ошибка доступа! API ключ для доступа к серверной части приложения (Backend) некорректный. Пожалуйста, обратитесь к администратору системы.
                  <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
                </td>
              </tr>
            </div>
            <div v-else-if="loadpublicationsinnstustatus === 6">
              <tr>
                <td class="helper-text invalid">
                  Не удается подключиться к серверу. Пожалуйста, попробуйте еще раз, сейчас или позже.
                  <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
                </td>
              </tr>
            </div>
            <div v-else-if="loadpublicationsinnstustatus === 1">
              <tr>
                <td class="helper-text invalid">
                <span v-if="checked === 'no'">
                Введенный Вами формат даты ({{yearName}}) некорректен!
                </span>
                  <span v-if="checked === 'yes'">
                Введенный Вами диапазон и (или) формат дат(ы) ({{yearName}}) некорректен! Дата начала периода не должна совпадать или быть больше даты окончания периода.
                </span>
                </td>
              </tr>
            </div>
          </div>
          <!--Дата некорректна-->
          <div v-else-if="getPublScopusIntermediateAmount === 1">
            <tr>
              <td class="helper-text invalid">
                <span v-if="checked === 'no'">
                Введенный Вами формат даты ({{yearName}}) некорректен!
                </span>
                <span v-if="checked === 'yes'">
                Введенный Вами диапазон и (или) формат дат(ы) ({{yearName}}) некорректен! Дата начала периода не должна совпадать или быть больше даты окончания периода.
                  <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
                </span>
              </td>
            </tr>
          </div>
          <!--API ключ для доступа к серверной части приложения (Backend) некорректный.-->
          <div v-else-if="getPublScopusIntermediateAmount === 5">
            <tr>
              <td class="helper-text invalid">
                Ошибка доступа! API ключ для доступа к серверной части приложения (Backend) некорректный. Пожалуйста, обратитесь к администратору системы.
                <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
              </td>
            </tr>
          </div>
          <!--В процессе операции (на стороне backend) произошла ошибка. Пожалуйста, обратитесь к администратору системы.-->
          <div v-else-if="getPublScopusIntermediateAmount === 4">
            <tr>
              <td class="helper-text invalid">
                В процессе операции (на стороне backend) произошла ошибка. Пожалуйста, обратитесь к администратору системы.
                <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
              </td>
            </tr>
          </div>
          <!--Не удается подключиться к серверу.-->
          <div v-else-if="getPublScopusIntermediateAmount === 6">
            <tr>
              <td class="helper-text invalid">
                Не удается подключиться к серверу. Пожалуйста, попробуйте еще раз, сейчас или позже.
                <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
              </td>
            </tr>
          </div>
        </table>
      </div>
    </div>
    <div class="col s12 m6 l4">
      <div class="card sticky-action" style="width:100%;" @submit.prevent="Get_reports">
        <!--        <tr><button :disabled="isButtonDisabled_3" class="btn btn-primary" @click="Get_reports">Просмотреть отчеты Excel<i class="material-icons right">send</i></button></tr>-->
        <table>
          <caption class="messageoutput">Архив отчетов о загрузке и проверке данных о публикациях в БД НГТУ</caption>
          <Loader v-if="loading_table"/>
          <div v-else>
            <td style="width:70%;">
              <table class="ftable" style="width:100%;">
                <div v-if="GetReportsStatus === 3">
                  <!--          <tr>История создания отчетов</tr> style="width:45%; -->
                  <div class="scroll">
                    <tr><th>№ строки</th><th>Код отчета</th><th>Дата и время создания отчета</th><th>Год выборки публикаций</th><th>Количество внесенных публикаций</th><th>Количество инцидентов</th><th>Кнопка для скачивания отчета</th></tr>
                    <tr
                      v-for="dataReport of GetReportsData"
                      :key="dataReport.id"
                    >
                      <td></td>
                      <td> {{ dataReport.ID_DATE_UPLOAD_DB }} </td>
                      <td> {{ (dataReport.DATE_UPLOAD.substring(0, dataReport.DATE_UPLOAD.length - 3))  | date('datetime') }}</td> <!--<td> {{ dataReport.DATE_UPLOAD | date('datetime') }}</td>-->
                      <td> {{ dataReport.DATE_UPLOAD_FILTER_PUBL}} </td>
                      <td> {{ dataReport.NUMBER_NEW_PUBLICATIONS}} </td>
                      <td> {{ dataReport.NUMBER_OF_INCIDENTS}} </td>
                      <td><button class="new" @click="Get_reports_excel(dataReport.ID_DATE_UPLOAD_DB)">Excel<i class="material-icons right">file_download</i></button></td>
                    </tr>
                  </div>
                </div>
                <!--Данных нет некорректна-->
                <div v-else-if="GetReportsStatus === 11">
                  <div class="scroll">
                    <tr><th>№ строки</th><th>Код отчета</th><th>Дата и время создания отчета</th><th>Год выборки публикаций</th><th>Количество внесенных публикаций</th><th>Количество инцидентов</th><th>Кнопка для скачивания отчета</th></tr>
                    <tr>
                      <th class="messageoutput" colspan="7">
                        Данных за указанный период не обнаружено
                      </th>
                    </tr>
                  </div>
                </div>
                <div v-else-if="GetReportsStatus === 4">
                  <div class="scroll">
                    <tr><th>№ строки</th><th>Код отчета</th><th>Дата и время создания отчета</th><th>Год выборки публикаций</th><th>Количество внесенных публикаций</th><th>Количество инцидентов</th><th>Кнопка для скачивания отчета</th></tr>
                    <tr>
                      <th class="helper-text invalid" colspan="7">
                        В процессе операции (на стороне backend) произошла ошибка. Пожалуйста, обратитесь к администратору системы.
                      </th>
                    </tr>
                  </div>
                </div>
                <div v-else-if="GetReportsStatus === 5">
                  <div class="scroll">
                    <tr><th>№ строки</th><th>Код отчета</th><th>Дата и время создания отчета</th><th>Год выборки публикаций</th><th>Количество внесенных публикаций</th><th>Количество инцидентов</th><th>Кнопка для скачивания отчета</th></tr>
                    <tr>
                      <th class="helper-text invalid" colspan="7">
                        Ошибка доступа! API ключ для доступа к серверной части приложения (Backend) некорректный. Пожалуйста, обратитесь к администратору системы.
                      </th>
                    </tr>
                  </div>
                </div>
                <div v-else-if="GetReportsStatus === 6">
                  <div class="scroll">
                    <tr><th>№ строки</th><th>Код отчета</th><th>Дата и время создания отчета</th><th>Год выборки публикаций</th><th>Количество внесенных публикаций</th><th>Количество инцидентов</th><th>Кнопка для скачивания отчета</th></tr>
                    <tr>
                      <th class="helper-text invalid" colspan="7">
                        Не удается подключиться к серверу. Пожалуйста, попробуйте применить фильтр еще раз, сейчас или позже.
                      </th>
                    </tr>
                  </div>
                </div>
                <div v-else-if="GetReportsStatus === 1">
                  <div class="scroll">
                    <tr><th>№ строки</th><th>Код отчета</th><th>Дата и время создания отчета</th><th>Год выборки публикаций</th><th>Количество внесенных публикаций</th><th>Количество инцидентов</th><th>Кнопка для скачивания отчета</th></tr>
                    <tr>
                      <th class="helper-text invalid" colspan="7">
                        Введенный Вами формат даты ({{yearPubl3}}) некорректен!
                      </th>
                    </tr>
                  </div>
                </div>
              </table>
            </td>
            <td>
              <tr class="no_line_tr">
                <span class="messageoutput">Фильтр для отображения созданных отчетов в разрезе даты их создания</span>
                <label>
                  <input class="with-gap" name="group1" type="radio" value="count5" v-model="checked_2"/>
                  <span>Вывести 5 последних отчетов</span>
                </label>
                <br>
                <label>
                  <input class="with-gap" name="group1" type="radio" value="all" v-model="checked_2"/>
                  <span>Вывести все отчеты</span>
                </label>
                <br>
                <label>
                  <input class="with-gap" name="group1" type="radio" value="years" v-model="checked_2"/>
                  <span>Вывести отчеты за конкретный год</span>
                  <span class="input-field">
                      <span v-if="checked_2 === 'years'">
                        :<input type="number" v-model="yearPubl3" id="Year_3" name="tentacles" min="1500" max="9999" style="width:60px; height:18px;" class="card-content red-text" :class="{ invalid: ( $v.yearPubl3.$dirty && !$v.yearPubl3.required && checked_2 === 'years') || ( $v.yearPubl3.$dirty && !$v.yearPubl3.minLength && checked_2 === 'years') }"> г.
                        <small
                          class="helper-text invalid"
                          v-if="$v.yearPubl3.$dirty && !$v.yearPubl3.required && checked_2 === 'years'"
                        >При выборе варианта 'Вывести отчеты за конкретный год' поле 'год' является обязательным для заполнения (формат данных: число)!
                        </small>
                        <small
                          class="helper-text invalid"
                          v-else-if="$v.yearPubl3.$dirty && !$v.yearPubl3.minLength && checked_2 === 'years'"
                        >Год должен состоять из {{ $v.yearPubl3.$params.minLength.min }} цифр. Сейчас количество цифр: {{yearPubl3.length}} шт.
                        </small>
                      </span>
                    </span>
                </label>
                <br>
                <button class="btn-small btn-primary" @click="Get_reports">Применить фильтр<i class="material-icons right">search</i></button>
              </tr>
            </td>
          </div>
        </table>
        <tr class="message_description_023">*При автоматической загрузке публикаций повторное внесение работ (дублирование) исключено. Публикации-дубли могут возникнуть только в случае, если автор публикации, не указавший свой идентификатор ‘Scopus AuthorID’ в личном кабинете НГТУ, решит самостоятельно внести в систему работу в тот момент, когда данная работа уже внесена в систему автоматически и находится, например, в стадии редактирования у соавторов работы (указавших ‘Scopus AuthorID’).</tr></div>
    </div>
  </div>
</template>

<style>
  .no_line_tr {
    border: none;
  }
  .ftable {
    border-collapse: collapse; /* Отображать только одинарные линии */
    counter-reset: schetchik; /* счётчик с названием "schetchik" работает в рамках класса .ftable */
  }
  .ftable tr > td:first-child {
    counter-increment: schetchik; /* при встрече тега tr счётчик с названием "schetchik" увеличивается на единицу */
  }
  .ftable tr td:first-child::before {
    content: counter(schetchik); /* значение счётчика с названием "schetchik" записывается в первую клетку строки */
    min-width: 1em;
    margin-right: 0.5em;
    vertical-align: middle;
    color: #978777;
  }
  .ftable th {
    border: 1px solid #E7D5C0;
    text-align: center;
  }
  .ftable td, tr:before {
    padding: .1em .5em;
    border: 1px solid #E7D5C0;
  }
  .colortext {
    color: #013f28;
    font-weight:bold;
  }
  .scroll {
    height:335px;
    /*width:300px;*/
    overflow-y:scroll;
    border:1px solid black;
    /*max-height: 400px;*/
  }
  .messageoutput {
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    color: #013f28;
    font-weight:bold;
  }
  .form_description{
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    font-size: 120%; /* Размер шрифта в процентах */
    font-weight: normal; /* Нормальное начертание */
    color: #013f28;
    font-style: italic; /* Курсивное начертание */
  }
  .message_description_023{
    color: black;
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    font-size: 100%; /* Размер шрифта в процентах */
    font-weight: normal; /* Нормальное начертание */
    text-align:justify;
    border: none;
    line-height: 1.2em;
    /*border: 1px solid black;*/
    /*padding: 5px; /* Поля вокруг текста *!*/
    /*vertical-align: top; /*  содержимое поднимется к его же верхней границе*!*/
  }
  /*table {*/
  /*  border-collapse: collapse;*/
  /*}*/

  /*table, th, td, tr {*/
  /*  border: 1px solid black;*/
  /*}*/
</style>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import { KEY } from '../../keys.js'
import { URLB } from '../../url'
export default {
  data () {
    return {
      loading_table: true,
      isButtonDisabled: false, /* блокировка нажатия кнопки 'Получить информацию' ИЗНАЧАЛЬНО: активная */
      isButtonDisabled_2: true, /* блокировка нажатия кнопки 'Загрузить публикации в БД НГТУ' ИЗНАЧАЛЬНО: заблокирована */
      isButtonDisabled_3: false,
      GetReportsData: [],
      yearPubl1: (new Date().getFullYear() - 1), /* года для ввода'  {{ date | date('year') }} */
      yearPubl2: new Date().getFullYear(), /* года для ввода' */
      yearPubl3: new Date().getFullYear(), /* года для ввода' */
      yearName: '', /* формирование года для api (конкретный год или диапазон)' */
      checked: 'no', /* переключатель год или диапазон в гг - отслеживание выбора пользователя ("yes"/"no")  */
      checked_2: '', /* переключатель вывести все отчеты - отслеживание выбора пользователя  */
      getPublScopusAmount: '', /* обнуление результата API при нажатии на кнопку 'Вывести кол-во публикаций для анализа при загрузке в БД' */
      loadpublicationsinnstuAPI: '',
      GetReportsExcelAPI: '',
      loading: true, /* на время выполнения api запроса скрывать поля с результатом */
      loading_2: true, /* на время выполнения api запроса скрывать поля с результатом */
      getPublScopusIntermediateAmount: 0,
      loadpublicationsinnstustatus: -1,
      GetReportsStatus: 0,
      GetReportsExcelStatus: 0,
      XELSCODE: 0,
      number_publications: 0,
      number_publications_add_nstu: 0,
      lenListPublId: 0,
      description: '',
      hours: 0, /* время выполнения операции */
      minutes: 0, /* время выполнения операции */
      seconds: 0, /* время выполнения операции */
      getReportsExcelstatus: 0,
      getReportsExcel: '',
      nameReportsExcel: '',
      statusGetReportsData: 0,
      filterReports: 0
    }
  },
  validations: {
    yearPubl1: {
      required,
      minLength: minLength(4)
    },
    yearPubl2: {
      required,
      minLength: minLength(4)
    },
    yearPubl3: {
      required,
      minLength: minLength(4)
    }
  },
  mounted () {
    this.checked_2 = 'count5'
    this.Get_reports()
  },
  methods: {
    Get_reports_excel (primaryReportsExcel) {
      this.primaryReportsExcel = primaryReportsExcel
      const apiKeyBack = KEY.APIKEY_BACKEND
      const urlBack = URLB.URL_BACKEND
      this.$http.get(`${urlBack}/api/content/report_creation/id/${this.primaryReportsExcel}?apiKey=${apiKeyBack}`)
        .then(response => {
          return response.json()
        })
        .catch(error => {
          console.log(error)
          this.GetReportsExcel = 6
        })
        .then(getReportsExcel => {
          this.getReportsExcel = getReportsExcel
          this.statusGetReportsExcel = getReportsExcel.X_ELS_CODE
          // console.log(getReportsExcel.file_name)
          if (this.statusGetReportsExcel === 1) {
            this.getReportsExcelstatus = 1
            return
          }
          if (this.statusGetReportsExcel === 3) {
            // this.GetReportsExcelstatus = 3
            this.nameReportsExcel = (getReportsExcel.file_name)
            this.handlePrint(this.nameReportsExcel)
          }
          if (this.statusGetReportsExcel === 4) {
            this.getReportsExcelstatus = 4
            return
          }
          if (this.statusGetReportsExcel === 5) {
            this.getReportsExcelstatus = 5
          }
        })
    },
    handlePrint (nameReportsExcel) {
      const apiKeyBack = KEY.APIKEY_BACKEND
      const urlBack = URLB.URL_BACKEND
      this.$http.get(`${urlBack}/api/content/generated_report/file_name/${nameReportsExcel}?apiKey=${apiKeyBack}`, { responseType: 'blob' })
        .then(response => {
          // console.log(response)
          // console.log(response.data)
          const url = URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', nameReportsExcel)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          // const link = document.createElement('a') +
          // link.href = response.data +-
          // document.body.appendChild(link) +
          // link.click() +
          // document.body.removeChild(link)
        })
    },
    Get_publ_scopus_intermediate_amount () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      this.hours = 0
      this.minutes = 0
      this.seconds = 0
      this.isButtonDisabled_2 = true /* неактивная кнопка выгрузки публикаций в промежуточную базу по API */
      this.loading = false
      this.isButtonDisabled = true /* неактивная кнопка расчета кол-ва публикаций, подл анализу */
      this.getPublScopusAmount = ''
      this.getPublScopusIntermediateAmount = 0
      this.loadpublicationsinnstustatus = -1
      var yearName
      // var yearname = this.year_publ[1]
      if (this.checked === 'no') {
        yearName = this.yearPubl2
      }
      if (this.checked === 'yes') {
        yearName = this.yearPubl1 + '-' + this.yearPubl2
      }
      this.yearName = yearName
      // var yearname = this.year_publ[1]
      const apiKeyBack = KEY.APIKEY_BACKEND
      const urlBack = URLB.URL_BACKEND
      this.$http.get(`${urlBack}/api/content/get_publ_scopus_intermediate_db_amount/date/${yearName}?apiKey=${apiKeyBack}`)
        .then(response => {
          return response.json()
        })
        .catch(error => {
          console.log(error)
          this.getPublScopusIntermediateAmount = 6
        })
        .then(getPublScopusAmount => {
          this.getPublScopusAmount = getPublScopusAmount
          this.loading = true
          this.isButtonDisabled = false
          this.statusGetPublScopusAmount = getPublScopusAmount.X_ELS_CODE
          if (this.statusGetPublScopusAmount === 1) {
            this.getPublScopusIntermediateAmount = 1
            return
          }
          if (this.statusGetPublScopusAmount === 3) {
            this.getPublScopusIntermediateAmount = 3
            this.lenListPublId = Number(getPublScopusAmount.number_publications)
            // this.description = (getPublScopusAmount.description)
            if (this.lenListPublId > 0) {
              this.isButtonDisabled_2 = false
              this.hours = Math.floor((this.lenListPublId * 1.8) / 60 / 60)
              this.minutes = Math.floor((this.lenListPublId * 1.8) / 60) - (this.hours * 60)
              this.seconds = Math.floor((this.lenListPublId * 1.8) % 60)
              // this.resultLoadingApiPubl = this.hours + ':' + this.minutes + ':' + this.seconds
            }
            return
          }
          if (this.statusGetPublScopusAmount === 5) {
            this.getPublScopusIntermediateAmount = 5
            return
          }
          if (this.statusGetPublScopusAmount === 4) {
            this.getPublScopusIntermediateAmount = 4
          }
        })
    },
    load_publications_in_nstu () {
      this.loadpublicationsinnstustatus = -1
      this.isButtonDisabled_2 = true
      this.loading_2 = false
      const apiKeyBack = KEY.APIKEY_BACKEND
      const urlBack = URLB.URL_BACKEND
      this.$http.get(`${urlBack}/api/content/scopus_loading_publ_nstu/date/${this.yearName}?apiKey=${apiKeyBack}`)
        .then(response => {
          return response.json()
        })
        .catch(error => {
          console.log(error)
          this.loadpublicationsinnstustatus = 6
        })
        .then(loadpublicationsinnstuAPI => {
          this.loading_2 = true
          this.isButtonDisabled_2 = false
          this.isButtonDisabled = false
          this.loadpublicationsinnstuAPI = loadpublicationsinnstuAPI
          this.statusDownloadPyblApi = Number(loadpublicationsinnstuAPI.X_ELS_CODE)
          if (this.statusDownloadPyblApi === 1) {
            this.loadpublicationsinnstustatus = 1
            return
          }
          if (this.statusDownloadPyblApi === 33) {
            this.loadpublicationsinnstustatus = 33
            this.number_publications_add_nstu = Number(loadpublicationsinnstuAPI.number_publications_add_nstu)
            this.checked_2 = 'count5'
            this.isButtonDisabled_2 = true
            this.Get_reports()
            return
          }
          if (this.statusDownloadPyblApi === 34) {
            this.loadpublicationsinnstustatus = 34
            this.number_publications_add_nstu = Number(loadpublicationsinnstuAPI.number_publications_add_nstu)
            // console.log(this.number_publications_add_nstu)
            // console.log(this.loadpublicationsinnstustatus)
            this.checked_2 = 'count5'
            this.isButtonDisabled_2 = true
            this.Get_reports()
            return
          }
          if (this.statusDownloadPyblApi === 35) {
            this.loadpublicationsinnstustatus = 35
            this.number_publications_add_nstu = Number(loadpublicationsinnstuAPI.number_publications_add_nstu)
            this.checked_2 = 'count5'
            this.isButtonDisabled_2 = true
            this.Get_reports()
            return
          }
          if (this.statusDownloadPyblApi === 36) {
            this.loadpublicationsinnstustatus = 36
            this.number_publications_add_nstu = Number(loadpublicationsinnstuAPI.number_publications_add_nstu)
            // console.log(this.loadpublicationsinnstuAPI)
            // console.log(this.number_publications_add_nstu)
            // console.log(this.loadpublicationsinnstustatus)
            this.checked_2 = 'count5'
            this.isButtonDisabled_2 = true
            this.Get_reports()
            return
          }
          if (this.statusDownloadPyblApi === 5) {
            this.loadpublicationsinnstustatus = 5
            return
          }
          if (this.statusDownloadPyblApi === 4) {
            this.loadpublicationsinnstustatus = 4
          }
        })
    },
    Get_reports () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      const apiKeyBack = KEY.APIKEY_BACKEND
      if (this.checked_2 === 'years') {
        this.filterReports = this.yearPubl3
      }
      if (this.checked_2 !== 'years') {
        this.filterReports = this.checked_2
      }
      const urlBack = URLB.URL_BACKEND
      this.$http.get(`${urlBack}/api/content/get_reports/sort/${this.filterReports}?apiKey=${apiKeyBack}`)
        .then(response => {
          return response.json()
        })
        .catch(error => {
          console.log(error)
          this.GetReportsStatus = 6
        })
        .then(GetReportsData => {
          this.loading_table = false
          this.statusGetReportsData = GetReportsData.X_ELS_CODE
          if (this.statusGetReportsData === 4) {
            this.GetReportsStatus = 4
            return
          }
          if (this.statusGetReportsData === 5) {
            this.GetReportsStatus = 5
            return
          }
          if (this.statusGetReportsData === 11) {
            this.GetReportsStatus = 11
            return
          }
          if (this.statusGetReportsData === 1) {
            this.GetReportsStatus = 1
            return
          }
          if (this.statusGetReportsData === 3) {
            this.GetReportsStatus = 3
            this.GetReportsData = GetReportsData.description
          }
        })
    },
    cleaningForm () {
      this.isButtonDisabled = false /* блокировка нажатия кнопки 'Получить информацию' ИЗНАЧАЛЬНО: активная */
      this.isButtonDisabled_2 = true /* блокировка нажатия кнопки 'Загрузить публикации в БД НГТУ' ИЗНАЧАЛЬНО: заблокирована */
      this.yearPubl1 = (new Date().getFullYear() - 1) /* года для ввода'  {{ date | date('year') }} */
      this.yearPubl2 = new Date().getFullYear() /* года для ввода' */
      this.yearName = '' /* формирование года для api (конкретный год или диапазон)' */
      this.checked = 'no' /* переключатель год или диапазон в гг - отслеживание выбора пользователя ("yes"/"no")  */
      this.getPublScopusAmount = '' /* обнуление результата API при нажатии на кнопку 'Вывести кол-во публикаций для анализа при загрузке в БД' */
      this.loadpublicationsinnstuAPI = ''
      this.loading = true /* на время выполнения api запроса скрывать поля с результатом */
      this.loading_2 = true /* на время выполнения api запроса скрывать поля с результатом */
      this.getPublScopusIntermediateAmount = 0
      this.loadpublicationsinnstustatus = -1
      this.XELSCODE = 0
      this.lenListPublId = 0
      this.description = ''
      this.hours = 0 /* время выполнения операции */
      this.minutes = 0 /* время выполнения операции */
      this.seconds = 0 /* время выполнения операции */
    }
  }
}
</script>
